import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';

export const MODULE_NAME = 'COMMENTS_MODULE';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');


export const ACTION_TYPES = {
  LOAD,
  LOAD_OK,
  LOAD_FAIL,

};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD:
        return  Object.assign({}, state, {loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {data: action.response, loading: false, error: null});
      case LOAD_FAIL:
        return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

export const API = {
  doLoad: () => {
    return (dispatch, getState) => {
      dispatch({type: LOAD});
      
      return CLIENT.getComments()
        .then((response) => {
          dispatch({type: LOAD_OK, response: response});
        })
        .catch((error) => {
          dispatch({type: LOAD_FAIL, error});
        });
    }
  },
  getCommentById: (comments, commentId) => {
    // TODO: Bit rubbish doing this every single time. Think of a better way.
    const commentArray = (comments && comments.data) || [];
    const commentDictionary = commentArray.reduce((dictionary, comment) => {
      dictionary[comment.id] = comment;
      return dictionary;
    }, {});
    return commentDictionary[commentId];

  },
  filterCommentsByReportId: (comments, reportId) => {
    // TODO: Bit rubbish doing this every single time. Think of a better way.
    const commentArray = (comments && comments.data) || [];
    const commentDictionary = commentArray.reduce((dictionary, comment) => {
      if (comment.commentType === "1" && comment.parentId === reportId)
      {
        dictionary[comment.id] = comment;
      }
      return dictionary;
    }, {});
    return commentDictionary;
  },
  filterCommentsByInvoiceId: (comments, invoiceId) => {
    // TODO: Bit rubbish doing this every single time. Think of a better way.
    const commentArray = (comments && comments.data) || [];
    const commentDictionary = commentArray.reduce((dictionary, comment) => {
      if (comment.commentType === "2" && comment.parentId === invoiceId)
      {
        dictionary[comment.id] = comment;
      }
      return dictionary;
    }, {});
    return commentDictionary;
  }
};

export default API;

